export function activeSwitcherLocations(list) {
  return (Array.isArray(list) ? list : []).filter((row) => row && row.is_active !== false);
}

// Matches ALL in businessSelection.js (kept import-free so the backend
// test can load this file directly).
const SAVED_ALL = 'all';

// Picks the switcher value once locations load. An explicit "All
// Businesses" choice (saved ALL) is kept instead of being
// replaced by the first location.
export function switcherSelection(currentId, savedId, active) {
  const rows = Array.isArray(active) ? active : [];
  const has = (id) => rows.some((row) => Number(row.id) === id);
  const current = Number(currentId);
  if (current && has(current)) return current;
  if (savedId === SAVED_ALL) return ''; // explicit All Businesses choice
  const saved = Number(savedId);
  if (saved && has(saved)) return saved;
  if (rows.length > 0) return rows[0].id;
  return '';
}
